import React from "react";
import SideBar from "./SideBar";
import Footer from "../../layout/Footer";
import Header from "../../layout/Header";
import { useNavigate } from "react-router-dom";
import HeroSection from "../../layout/HeroSection";
import { pageRoutes } from "../../routes/pageRoutes";
import { pipGetProfile } from "../../utils/pip";

const MyAccount = () => {
  const {name} = pipGetProfile() 
  const navigate = useNavigate();
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 className="mb-1">{"Dashboard"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}` },
          { name: "Dashboard", path: `${pageRoutes?.home}` },
        ]}
      />
      <div class="untree_co-section ">
        <div class="container">
          <div class="row mb-5">
            <SideBar />
            <div class="col-md-8 offset-md-1 mb-4">
              <div class="ct_my_account_right">
                <p>
                  Hello {name} (not {name}?{" "}
                  <a
                    data-bs-toggle="modal"
                    data-bs-target="#ct_logout_modal"
                    href="javascript:void(0)"
                    class="ct_yellow_clr"
                  >
                    {" "}
                    Log out
                  </a>
                  )
                   {/* From your account dashboard you can view your{" "} */}
                  {/* <a
                    href="javascript:void(0)"
                    onClick={() => navigate(pageRoutes?.myOrders)}
                    class="ct_yellow_clr"
                  >
                    recent orders
                  </a>
                  , manage your{" "}
                  <a href="javascript:void(0)"
                  class="ct_yellow_clr"
                    onClick={() => navigate(pageRoutes?.addressDetail)}>
                    {" "}
                    shipping and billing addresses.
                  </a>
                  */}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default MyAccount;
